import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQuoteLeft, faExternalLinkAlt, faUsers, faHeart } from '@fortawesome/free-solid-svg-icons';

const Resenas = () => {
  const testimonials = [
    {
      id: 1,
      name: "Maria Fernandez",
      occasion: "Aniversario de Bodas",
      image: "/assets/images/clientes/IMG_5881.JPG",
      rating: 5,
      text: "Celebramos nuestro aniversario de bodas en familia y ADASTRA hizo que la noche fuera realmente especial. El ambiente acogedor con la iluminación cálida y las plantas tropicales creó el escenario perfecto. Nuestro hijo también disfrutó mucho y el personal fue increíblemente atento con toda la familia. Una experiencia gastronómica que nos conectó como familia.",
      date: "Octubre 2024",
      highlight: "Ambiente familiar perfecto"
    },
    {
      id: 2,
      name: "Carlos y Elena Rodriguez",
      occasion: "Celebración Familiar",
      image: "/assets/images/eventos/_AMC1893.JPEG",
      rating: 5,
      text: "Organizamos una reunión familiar de 20 personas y ADASTRA superó todas nuestras expectativas. La terraza privada fue el espacio perfecto, la comida espectacular y el servicio impecable. Nuestros abuelos quedaron encantados con los sabores tradicionales reinventados.",
      date: "Septiembre 2024",
      highlight: "Evento familiar perfecto"
    },
    {
      id: 3,
      name: "Isabel Martinez",
      occasion: "Cena Corporativa",
      image: "/assets/images/clientes/pareja-cena-romantica-aceite.jpg",
      rating: 5,
      text: "Como directora ejecutiva, he organizado cenas corporativas en muchos lugares, pero ADASTRA es excepcional. La presentación de los platos es arte puro, el ambiente sofisticado pero acogedor, y el menú degustación fue una experiencia sensorial completa para nuestros clientes internacionales.",
      date: "Agosto 2024",
      highlight: "Profesionalismo y excelencia"
    }
  ];

  const stats = [
    { number: "500+", label: "Experiencias compartidas" },
    { number: "4.9/5", label: "Calificación promedio" },
    { number: "98%", label: "Recomendarían ADASTRA" }
  ];

  return (
    <div className="min-h-screen bg-white">
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Image Background */}
        <img 
          src="/assets/images/restaurant/Fachada.JPG"
          alt="Fachada de ADASTRA - Restaurante"
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40" />
        
        {/* Content */}
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="font-sans text-5xl md:text-7xl font-light leading-tight mb-6">
            Experiencias que <span className="text-green-400 font-normal italic">ADASTRA</span> inspira
          </h1>
          <p className="font-sans text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed opacity-90">
            Cada visita a nuestro restaurante se convierte en una historia única. 
            Descubre lo que nuestros huéspedes tienen que compartir sobre sus momentos especiales.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="container-custom max-w-7xl mx-auto px-6">
        
        {/* Section Title */}
        <div className="text-center py-20">
          <h2 className="font-sans text-5xl md:text-6xl font-light text-gray-900 leading-tight mb-8">
            Historias <span className="text-green-600 font-normal italic">auténticas</span>
          </h2>
          <div className="w-24 h-0.5 bg-gradient-to-r from-green-600 to-transparent mx-auto mb-8"></div>
          <p className="font-sans text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Momentos inolvidables, sabores excepcionales y recuerdos que perduran. 
            Estas son las voces de quienes han vivido la experiencia ADASTRA.
          </p>
        </div>

        {/* Statistics Section */}
        <div className="mb-20 bg-gray-50 rounded-2xl p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {stats.map((stat, index) => (
              <div key={index} className="space-y-2">
                <div className="text-4xl md:text-5xl font-light text-green-600 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-700 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="space-y-20 mb-20">
          {testimonials.map((testimonial, index) => (
            <div key={testimonial.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              
              {/* Image */}
              <div className={`relative ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src={testimonial.image}
                    alt={`Experiencia de ${testimonial.name} en ADASTRA`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
                {/* Floating badge */}
                <div className="absolute -top-4 -right-4 bg-green-600 text-white rounded-full p-4 shadow-lg">
                  <FontAwesomeIcon icon={faStar} className="w-6 h-6" />
                </div>
              </div>

              {/* Content */}
              <div className={`space-y-6 ${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                {/* Stars */}
                <div className="flex space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FontAwesomeIcon key={i} icon={faStar} className="w-5 h-5 text-yellow-400" />
                  ))}
                </div>

                {/* Quote */}
                <div className="relative">
                  <FontAwesomeIcon icon={faQuoteLeft} className="absolute -top-2 -left-2 w-8 h-8 text-green-600/20" />
                  <blockquote className="font-sans text-xl text-gray-700 leading-relaxed italic pl-6">
                    "{testimonial.text}"
                  </blockquote>
                </div>

                {/* Author Info */}
                <div className="border-t border-gray-200 pt-6">
                  <div className="font-semibold text-gray-900 text-lg">
                    {testimonial.name}
                  </div>
                  <div className="text-green-600 font-medium">
                    {testimonial.occasion}
                  </div>
                  <div className="text-gray-500 text-sm">
                    {testimonial.date}
                  </div>
                  <div className="mt-3 inline-flex items-center space-x-2 bg-green-50 text-green-700 px-3 py-1 rounded-full text-sm">
                    <FontAwesomeIcon icon={faHeart} className="w-3 h-3" />
                    <span>{testimonial.highlight}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action Section */}
        <div className="mb-20 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-12 md:p-16 text-center">
          <div className="max-w-3xl mx-auto space-y-8">
            
            <div className="space-y-6">
              <h3 className="font-sans text-4xl md:text-5xl font-light text-gray-900 leading-tight">
                Comparte tu experiencia <span className="text-green-600 font-normal italic">ADASTRA</span>
              </h3>
              <p className="font-sans text-lg text-gray-600 leading-relaxed">
                ¿Has vivido un momento especial en nuestro restaurante? Nos encantaría conocer tu historia. 
                Tu experiencia puede inspirar a otros a crear sus propios recuerdos inolvidables.
              </p>
            </div>

            {/* User Icons */}
            <div className="flex justify-center space-x-4">
              <div className="flex -space-x-2">
                <img 
                  src="/assets/images/clientes/cliente-booth-sonriente.jpg" 
                  alt="Cliente feliz" 
                  className="w-12 h-12 rounded-full border-3 border-white object-cover"
                />
                <img 
                  src="/assets/images/clientes/cliente-cocktail-sonriente.jpg" 
                  alt="Cliente con coctel" 
                  className="w-12 h-12 rounded-full border-3 border-white object-cover"
                />
                <img 
                  src="/assets/images/clientes/cliente-joven-bebida.jpg" 
                  alt="Cliente joven con bebida" 
                  className="w-12 h-12 rounded-full border-3 border-white object-cover"
                />
                <img 
                  src="/assets/images/clientes/selfie-mural-vestido-verde.jpg" 
                  alt="Cliente selfie mural" 
                  className="w-12 h-12 rounded-full border-3 border-white object-cover"
                />
              </div>
            </div>

            {/* CTA Button */}
            <div className="pt-4">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSc0xvHdGPGjrAeOodCdROxfmmVWDZSy7HYayxWUjIUxUbAGqQ/viewform"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-gray-900 text-gray-900 px-8 py-3 font-bold tracking-wide hover:bg-gray-900 hover:text-white transition-all duration-300 inline-flex items-center justify-center w-auto"
              >
                <span>DEJA TU RESEÑA</span>
              </a>
              <p className="text-sm text-gray-500 mt-4">
                Solo toma 3 minutos • Completamente anónimo si lo prefieres
              </p>
            </div>

          </div>
        </div>

        {/* Secondary CTA */}
        <div className="text-center pb-20">
          <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-lg max-w-2xl mx-auto">
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-4">
              ¿Prefieres contarnos en persona?
            </h4>
            <p className="text-gray-600 mb-6">
              Nuestro equipo siempre está disponible para escuchar tus comentarios y sugerencias directamente.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:+5363518498" 
                className="border border-gray-900 text-gray-900 px-8 py-3 font-bold tracking-wide hover:bg-gray-900 hover:text-white transition-all duration-300 inline-flex items-center justify-center w-auto"
              >
                LLAMAR AHORA
              </a>
              <a 
                href="https://wa.me/5363518498" 
                target="_blank" 
                rel="noopener noreferrer"
                className="border border-gray-900 text-gray-900 px-8 py-3 font-bold tracking-wide hover:bg-gray-900 hover:text-white transition-all duration-300 inline-flex items-center justify-center w-auto"
              >
                WHATSAPP
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Resenas;